import { call, select, put, all } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import { createQadraSaga } from './shared';
import {
  INVESTMENT_OBJECTIVES_PATCH,
  INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET,
  INVESTMENT_OBJECTIVE_GET,
  ACCOUNT_INVESTMENT_OBJECTIVES_GET,
  ACCOUNT_INVESTMENT_OBJECTIVES_POST_PATCH,
  INVESTMENT_OBJECTIVE_PORTFOLIOS_GET,
  INVESTMENT_OBJECTIVES_CHANGE_REQUEST,
  INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_POST,
} from '../actions/types';
import {
  apiInvestmentObjectivesPatch,
  apiInvestmentObjectivePortfolioProposalsGet,
  apiInvestmentObjectivePortfolioProposalsPost,
  apiInvestmentObjectivePortfoliosGet,
  apiInvestmentObjectiveGet,
  apiInvestmentObjectivesChangeRequest,
} from '../api/investmentObjectives';
import {
  apiAccountInvestmentObjectivesGet,
  apiAccountInvestmentObjectivesPost,
} from '../api/account';
import { actionModalOpen } from '../actions';

export function* accountInvestmentObjectivesGet({ payload: { accountId } }) {
  const { investmentObjectives } = yield call(apiAccountInvestmentObjectivesGet, accountId);
  yield put({
    type: ACCOUNT_INVESTMENT_OBJECTIVES_GET._SUCCESS,
    payload: { investmentObjectives, accountId },
  });
}

const watchAccountInvestmentObjectivesGet = createQadraSaga(accountInvestmentObjectivesGet, {
  action: ACCOUNT_INVESTMENT_OBJECTIVES_GET._REQUEST,
});

export function* accountInvestmentObjectivesPostPatch({
  payload: { accountId, url, onFinish, investmentObjectiveId, investmentObjective },
}) {
  const userId = yield select((s) => s.app.user.id);

  if (investmentObjectiveId) {
    yield call(apiInvestmentObjectivesPatch, investmentObjectiveId, {
      userId,
      ...investmentObjective,
    });
  } else {
    yield call(apiAccountInvestmentObjectivesPost, accountId, {
      userId,
      ...investmentObjective,
    });
  }

  yield accountInvestmentObjectivesGet({ payload: { accountId } });

  if (url) yield put(push(url));
  if (onFinish) yield onFinish();
}

const watchAccountInvestmentObjectivesPostPatch = createQadraSaga(
  accountInvestmentObjectivesPostPatch,
  { action: ACCOUNT_INVESTMENT_OBJECTIVES_POST_PATCH._REQUEST }
);

function* investmentObjectivesPatch({ payload: { id, url, investmentObjective, accountId } }) {
  const userId = yield select((s) => s.app.user.id);
  yield call(apiInvestmentObjectivesPatch, id, { userId, ...investmentObjective });
  yield accountInvestmentObjectivesGet({ payload: { accountId } });

  yield put(push(url));
}

const watchInvestmentObjectivesPatch = createQadraSaga(investmentObjectivesPatch, {
  action: INVESTMENT_OBJECTIVES_PATCH._REQUEST,
});

function* investmentObjectivesChangeRequest({ payload: { id, desiredVar, message } }) {
  yield call(apiInvestmentObjectivesChangeRequest, id, { desiredVar, message });
  yield put(actionModalOpen('ModalChangeRequestSuccess'));
}

const watchInvestmentObjectivesChangeRequest = createQadraSaga(investmentObjectivesChangeRequest, {
  action: INVESTMENT_OBJECTIVES_CHANGE_REQUEST._REQUEST,
});

export function* investmentObjectivePortfolioProposalsGet({
  payload: { investmentObjectiveId, investmentObjectiveIds },
}) {
  if (investmentObjectiveIds) {
    const calls = investmentObjectiveIds.map((id) =>
      call(apiInvestmentObjectivePortfolioProposalsGet, id)
    );
    const res = yield all(calls);
    const payload = investmentObjectiveIds.map((id, i) => ({
      id,
      portfolioProposals: res[i].portfolioProposals,
    }));
    yield put({ type: INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET._SUCCESS, payload });
  } else {
    const { portfolioProposals } = yield call(
      apiInvestmentObjectivePortfolioProposalsGet,
      investmentObjectiveId
    );
    yield put({
      type: INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET._SUCCESS,
      payload: [{ id: investmentObjectiveId, portfolioProposals }],
    });
  }
}

const watchInvestmentObjectivePortfolioProposalsGet = createQadraSaga(
  investmentObjectivePortfolioProposalsGet,
  { action: INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET._REQUEST }
);

export function* investmentObjectiveGet({
  payload: { investmentObjectiveId, investmentObjectiveIds },
}) {
  if (investmentObjectiveIds) {
    const calls = investmentObjectiveIds.map((id) => call(apiInvestmentObjectiveGet, id));
    const res = yield all(calls);
    const payload = investmentObjectiveIds.map((id, i) => ({
      id,
      investmentObjective: res[i].investmentObjective,
    }));
    yield put({ type: INVESTMENT_OBJECTIVE_GET._SUCCESS, payload });
  } else {
    const { investmentObjective } = yield call(apiInvestmentObjectiveGet, investmentObjectiveId);
    yield put({
      type: INVESTMENT_OBJECTIVE_GET._SUCCESS,
      payload: [{ id: investmentObjectiveId, investmentObjective }],
    });
  }
}

const watchInvestmentObjectiveGet = createQadraSaga(investmentObjectiveGet, {
  action: INVESTMENT_OBJECTIVE_GET._REQUEST,
});

export function* investmentObjectivePortfolioProposalsPost({
  payload: { investmentObjectiveId, ...portfolioProposal },
}) {
  yield call(
    apiInvestmentObjectivePortfolioProposalsPost,
    investmentObjectiveId,
    portfolioProposal
  );
  yield investmentObjectiveGet({ payload: { investmentObjectiveId } });
}

const watchInvestmentObjectivePortfolioProposalsPost = createQadraSaga(
  investmentObjectivePortfolioProposalsPost,
  { action: INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_POST._REQUEST }
);

export function* investmentObjectivePortfoliosGet({ payload: { accountId } }) {
  const { portfolios } = yield call(apiInvestmentObjectivePortfoliosGet, accountId);

  yield put({
    type: INVESTMENT_OBJECTIVE_PORTFOLIOS_GET._SUCCESS,
    payload: { portfolios, accountId },
  });
}

const watchInvestmentObjectivePortfoliosGet = createQadraSaga(investmentObjectivePortfoliosGet, {
  action: INVESTMENT_OBJECTIVE_PORTFOLIOS_GET._REQUEST,
});

export default [
  watchInvestmentObjectiveGet,
  watchAccountInvestmentObjectivesGet,
  watchAccountInvestmentObjectivesPostPatch,
  watchInvestmentObjectivesChangeRequest,
  watchInvestmentObjectivesPatch,
  watchInvestmentObjectivePortfolioProposalsGet,
  watchInvestmentObjectivePortfolioProposalsPost,
  watchInvestmentObjectivePortfoliosGet,
];
